import React from "react";
import Lineage from "../lineage";

function RightSidebar() {
  return <Lineage />;
}

export default RightSidebar;
